import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { inject, InjectionToken, ModuleWithProviders, NgModule, provideAppInitializer } from '@angular/core';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { AppConfig } from './app.config';
import { ConfigService } from './config.service';

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const APP_CONFIG = new InjectionToken<any>('OYAN_APP_CONFIG');

@NgModule({
  imports: [],
  providers: [
    ConfigService,
    provideAppInitializer(() => {
      const initializerFn = (
        (configService: ConfigService) => async () =>
          await firstValueFrom(configService.init())
      )(inject(ConfigService));
      return initializerFn();
    }),
    provideHttpClient(withXhr(), withInterceptorsFromDi())
  ]
})
export class ConfigModule {
  static forRoot(config: AppConfig): ModuleWithProviders<ConfigModule> {
    return {
      ngModule: ConfigModule,
      providers: [
        {
          provide: APP_CONFIG,
          useValue: config
        }
      ]
    };
  }
}
